import { Box, Grid } from "@mui/material";
import ExtractorExplorer from "../../components/organisms/extractorExplorer/ExtractorExplorer";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getRoleClaimsSelector } from "../../store/auth/selectors";

const DataExtractorList = () => {
    const pathname = window.location.pathname
    const getTitle = window.location.pathname==="/DataExtractorList" ? pathname.replace("/DataExtractorList", "") :pathname.replace("/DataExtractorList/", " - ");
    const { sourceName } = useParams();

    // const navigate = useNavigate();

    // const addNewSet = () => {
    //     navigate("/AddDataSet");
    // }

    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = useState(true);
    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);


    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <h1 style={{ textAlign: "left" }}>Data Extractors {getTitle} </h1>
                    </Grid>
                </Grid>
            </Box>
            <ExtractorExplorer selectable={"no"} displayIcons={true} sourceName={sourceName} displayActionButtons={true} isAdmin={isAdmin} />
        </>
    )
}

export default DataExtractorList;